import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material';
import { LocationDescriptor } from 'react-admin';
import { CircularProgress } from 'shared/mui/CircularProgress/CircularProgress';
import { getLinkParams } from 'utils';

interface Props {
  isLoading?: boolean;
  to?: string | LocationDescriptor;
  target?: string;
  label?: string;
  sx?: SxProps<Theme>;
}

export type ButtonProps = Props & MuiButtonProps;

export const Button = ({
  label,
  color = 'primary',
  size = 'medium',
  to: locationDescriptor,
  isLoading,
  startIcon,
  ...rest
}: ButtonProps) => {
  const linkParams = getLinkParams(locationDescriptor);

  return (
    <MuiButton
      {...rest}
      {...linkParams}
      color={color}
      disabled={rest.disabled || isLoading}
      size={size}
      startIcon={startIcon || (isLoading && <CircularProgress color="secondary" size={16} />)}
    >
      {label}
    </MuiButton>
  );
};
